export default __webpack_public_path__ + "static/media/game.83999416.svg";